import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import './ExchangeFromForm.scss';

import ExpandedFundList from '../../Buy/BuyFlow/ExpandedFundList/ExpandedFundList';
import CollegeExchangeDisclaimerNote from '../../CollegeExchange/CollegeExchangeDisclaimerNote/CollegeExchangeDisclaimerNote';
import ExchangeFromFundEditor from '../ExchangeFromFundEditor/ExchangeFromFundEditor';
import { setShowAllFundsStep } from '../../../redux/modules/quickBuy/quickBuy.module';
import * as exchangeActions from '../../../redux/modules/exchangeTransaction/exchangeTransaction.module';
import {
  getCollegeExchangeFromFundList,
  getExchangeFromFundListWithout529,
  getExchangeFromTotalDollars,
} from '../../../redux/modules/exchangeTransaction/exchangeTransaction.selectors';
import { openModal } from '../../../redux/modules/modals/modals.module';
import {
  getUserFundList,
  getQuickBuyProductType,
} from '../../../redux/modules/shoppingCart/shoppingCart.selectors';

import { ExchangeType } from '../../../settings/settings';
import RadioButton from '../../Shared/RadioButton/RadioButton';
import StepExpanded from '../../Shared/StepExpanded/StepExpanded';
import { isCollegeExchange } from '../../../utils/transactions-util';
import words from '../../../utils/words';
import { getMarketVolatility } from '../../../redux/modules/marketVolatility/marketVolatility.selectors';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';
import { getSystematicActivityRMDs } from '../../../redux/modules/RMD/RMDSetting.selectors';

const ExchangeFromForm = ({
  isSalesforceRep,
  customerWebViewEnabled,
  actions,
  actions: { selectExchangeType },
  exchangeFromFundList,
  exchangeType,
  exchangeFromTotalDollars,
  marketVolatility,
  userFunds,
  userFundsList,
  quickBuyProductType,
  systematicActivityRMDs,
}) => (
  <StepExpanded stylename="exchange-from-form-container">
    {isCollegeExchange() && <CollegeExchangeDisclaimerNote />}
    <div className="exchange-from-form-exchange-type">
      <div className="exchange-from-form-exchange-type-label">
        I Want to Exchange From:
      </div>
      <div className="exchange-from-form-exchange-type-selections">
        <RadioButton
          checked={exchangeType === ExchangeType.ONE_TO_ONE}
          className="e2e-one-to-one exchange-from-form-exchange-type-radio"
          onChange={selectExchangeType}
          labelText={`One ${words.Investment} to Another ${words.Investment}`}
          value={ExchangeType.ONE_TO_ONE}
        />

        <RadioButton
          checked={exchangeType === ExchangeType.ONE_TO_MANY}
          className="e2e-one-to-many exchange-from-form-exchange-type-radio"
          onChange={selectExchangeType}
          labelText={`One ${words.Investment} to Multiple ${words.Investments}`}
          disabled={quickBuyProductType === 'ManagedAccount'}
          value={ExchangeType.ONE_TO_MANY}
        />

        <RadioButton
          checked={exchangeType === ExchangeType.MANY_TO_ONE}
          className="e2e-many-to-one exchange-from-form-exchange-type-radio"
          onChange={selectExchangeType}
          labelText={`Multiple ${words.Investments} to One ${words.Investment}`}
          value={ExchangeType.MANY_TO_ONE}
        />
      </div>
    </div>
    <div
      className={`exchange-from-form-fund-list ${
        exchangeType === ExchangeType.MANY_TO_ONE
          ? ''
          : 'exchange-from-form-single-select'
      }`}
    >
      <ExpandedFundList
        isSalesforceRep={isSalesforceRep}
        customerWebViewEnabled={customerWebViewEnabled}
        actions={actions}
        availableFunds={exchangeFromFundList}
        currentYearInclusiveRemainingContributions={null}
        exchangeType={exchangeType}
        fundEditor={() => ExchangeFromFundEditor}
        IRALimit={{ data: { currentYearRemainingContributions: null } }}
        exchangeFromTotalDollars={exchangeFromTotalDollars}
        marketVolatility={marketVolatility}
        numberOfFunds={userFundsList.length}
        personalData={{}}
        priorYearInclusiveRemainingContributions={null}
        quickBuy={{}}
        shoppingCart={{}}
        userFunds={userFunds}
        systematicActivityRMDs={systematicActivityRMDs}
      />
    </div>
  </StepExpanded>
);

const mapStateToProps = (state) => {
  const {
    exchangeTransaction: { exchangeType },
    userFunds,
  } = state;
  return {
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    exchangeFromFundList: isCollegeExchange()
      ? getCollegeExchangeFromFundList(state)
      : getExchangeFromFundListWithout529(state),
    exchangeType,
    exchangeFromTotalDollars: getExchangeFromTotalDollars(state),
    marketVolatility: getMarketVolatility(state),
    userFunds,
    userFundsList: getUserFundList(state),
    quickBuyProductType: getQuickBuyProductType(state),
    systematicActivityRMDs: getSystematicActivityRMDs(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  const {
    deselectExchangeFromFund,
    selectExchangeFromFund,
    selectExchangeType,
    updateExchangeFromFundAmount,
    updateExchangeFromFundUnit,
    updateExchangeFund,
  } = exchangeActions;
  return {
    actions: bindActionCreators(
      {
        deselectFund: deselectExchangeFromFund,
        openModal,
        selectExchangeType,
        selectFund: selectExchangeFromFund,
        setShowAllFundsStep,
        updateExchangeFundAmount: updateExchangeFromFundAmount,
        updateExchangeFundUnit: updateExchangeFromFundUnit,
        updateExchangeFund,
      },
      dispatch
    ),
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ExchangeFromForm
);
